import { useEffect, useState } from 'react';
import { SideNavigation } from '@pmi/dsm-react';
import { NavItem } from '@pmi/dsm-react/dist/components/side-navigation/types';
import { useLocation, useNavigate } from 'react-router-dom';
import { reportLinkClick } from '../../analytics';
import './sidenav.scss';
import HelpGuides from './HelpGuides';

export interface SideNavProps {
  items: NavItem[];
  title?: string;
  className?: string;
}

export function getCurrentNavItem(items: NavItem[], pathname: string): string {
  if (Array.isArray(items) && items.length > 0) {
    const current: NavItem[] = items.filter((i: NavItem) => {
      const item = { ...{ href: '' }, ...i };
      if (item.href.length > 0) {
        return pathname.startsWith(item.href.toString());
      }
      return (
        i.link && i.link.href && pathname.startsWith(i.link.href.toString())
      );
    });
    if (current.length > 0) {
      return current[current.length > 1 ? current.length - 1 : 0].id;
    }
  }
  return '';
}

export default function SideNav({
  items,
  title = undefined,
  className = undefined,
}: SideNavProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedNavId, setSelectedNavId] = useState('');
  const [links, setLinks] = useState<NavItem[]>([]);
  const linkModule = location.pathname.startsWith('/hub/')
    ? 'b2bhub_sidenav'
    : 'b2badmin_sidenav';
  const onClick = (event: unknown, item: NavItem) => {
    (event as Event)?.preventDefault();
    reportLinkClick(item.title, item?.link?.href as string, linkModule);
    setSelectedNavId(item.id);
    const url = item.link.href.toString();

    if (url) {
      if (!item.link.href.toString().startsWith('http')) {
        navigate(url, { state: { fromSideNav: true } });
      } else {
        window.location.href = url;
      }
    }
  };
  useEffect(() => {
    setLinks(
      items?.map((i) => ({
        ...i,
        ...{ icon: undefined, children: i.children ?? [] },
      })),
    );
    setSelectedNavId(getCurrentNavItem(items, location.pathname));
  }, [items, location]);
  useEffect(
    () => setSelectedNavId(getCurrentNavItem(items, location.pathname)),
    [],
  );

  return (
    <div className="h-100 sideNavBoxWrapper">
      <div
        id="sideNavBox"
        style={{
          height: '100%',
        }}
      >
        <div
          id="sideNav"
          className="flex-column sideNav"
          style={{
            position: 'sticky',
            top: 0,
            background: '#fff',
          }}
          data-adoberegion={linkModule}
        >
          {links?.length > 0 && (
            <SideNavigation
              version="v2"
              navigation={links}
              title={title}
              className={`${className || ''} sideNavCtr`}
              onClick={onClick}
              selectedNavItemId={selectedNavId}
            />
          )}
        </div>
      </div>
      {items?.length > 0 && (
        <div className="helpGuideSticky">
          <div>
            <HelpGuides isAdminNav={linkModule === 'b2badmin_sidenav'} />
          </div>
        </div>
      )}
    </div>
  );
}
